import { makeStyles } from '@material-ui/core';

/**
 * Pipeline 卡片共享样式
 */
export const usePipelineCardStyles = makeStyles(theme => ({
  card: {
    height: 200,
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    overflow: 'hidden',
  },
  cardHeader: {
    padding: theme.spacing(2),
    '& .MuiCardHeader-content': {
      overflow: 'hidden',
      minWidth: 0,
    },
  },
  cardTitle: {
    fontWeight: 600,
    fontSize: '0.95rem',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  cardContent: {
    padding: theme.spacing(0, 2, 2),
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    '&:last-child': {
      paddingBottom: theme.spacing(2.5),
    },
  },
  infoSection: {
    flexGrow: 1,
    marginBottom: theme.spacing(1),
  },
  infoLine: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
    fontSize: '0.75rem',
  },
  actionButtons: {
    marginTop: 'auto',
    display: 'flex',
    gap: theme.spacing(1),
  },
  executeButton: {},
  cancelButton: {
    borderColor: 'rgba(0, 0, 0, 0.23)',
    color: 'rgba(0, 0, 0, 0.6)',
    '&:hover': {
      borderColor: 'rgba(0, 0, 0, 0.4)',
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
  runningStatus: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1),
  },
  statusDots: {
    display: 'flex',
    gap: theme.spacing(0.75),
    alignItems: 'center',
  },
  statusDot: {
    width: 12,
    height: 12,
    borderRadius: '50%',
    display: 'inline-block',
    border: '1px solid rgba(0, 0, 0, 0.1)',
  },
}));
